import { FC } from 'react';

import { useField } from 'formik';

import DisplayCard from 'src/components/Card/DisplayCard';
import { Flex } from 'src/components/Flex';
import { useAuthContext } from 'src/contexts/AuthProvider';
interface TotalAmountsProps {
    totalNetAmount: number;
    totalOutstanding: number;
    totalVatAmount: number;
    totalInvoiceAmount: number;
}

export const TotalAmounts: FC<TotalAmountsProps> = ({
    totalInvoiceAmount,
    totalNetAmount,
    totalVatAmount,
    totalOutstanding,
}) => {
    const { usersCurrency } = useAuthContext();
    const [{ value: balance }] = useField('balance');

    return (
        <Flex gap="19px">
            <DisplayCard
                label="Total Net Amount"
                value={`${usersCurrency}${totalNetAmount.toFixed(2)}`}
            />
            <DisplayCard
                label="Total Vat Amount"
                value={`${usersCurrency}${totalVatAmount.toFixed(2)}`}
            />
            <DisplayCard
                label="Total Invoice Amount"
                value={`${usersCurrency}${totalInvoiceAmount.toFixed(2)}`}
            />

            <DisplayCard
                label="Invoice Amount Outstanding"
                value={`${usersCurrency}${totalOutstanding.toFixed(2)}`}
            />
        </Flex>
    );
};
